export default function ({ error }, inject) {
  inject('handleError', (customError) => {
    error(customError)
  })
}
